import {isPlatform} from "@ionic/react";

type AppId = 'com.exactsystems.exactpeoplego' | 'com.exactsystems.exact.people';

export const getAppId = (): AppId => {
    if (isPlatform('ios')) {
        return 'com.exactsystems.exactpeoplego';
    } else {
        return 'com.exactsystems.exact.people';
    }
}